/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Channels extends CacheEnabledApiClient {
  constructor() {
    super('channels', { accountScoped: true });
  }

  // Override show to pass channel type as query param
  show(channelId, channelType) {
    return axios.get(`${this.url}/${channelId}`, {
      params: { channel_type: channelType },
    });
  }

  // Override update to pass channel type as query param
  update(channelId, channelType, params) {
    return axios.patch(`${this.url}/${channelId}`, params, {
      params: { channel_type: channelType },
    });
  }

  delete(channelId, channelType) {
    return axios.delete(`${this.url}/${channelId}`, {
      params: { channel_type: channelType },
    });
  }
}

export default new Channels();
